<mat-icon mat-dialog-close class="btn-close float-right">close</mat-icon>
<mat-dialog-content class="contentModal">
    <div class="container-fluid" loader [switch]="loader">
        <div class="aling">
            <div class="table-sio w-100 ">
                <div class="row-sio w-100">
                    <div class="cell-sio w-100">
                        <div class="padding-txt">
                            <label class="font-titleTxt">Recibe asesoría personalizada</label><br>
                        </div>
                        <div class="padding-txt">
                            <label class="font-marcameTxt">Puedes marcarnos al:</label><br>
                        </div>
                        <div class="padding-txt">
                            <label class="font-numero">55442 46837</label><br>
                        </div>
                        <div class="padding-txt">
                            <label class="font-marcameTxt">O escribe tu número y nos comunicaremos contigo </label>
                        </div>
                    </div>
                </div>
                <div class="row-sio w-100">
                    <div class="cell-sop w-100">
                        <mat-form-field class="aling">
                            <input matInput id="btnTelefono" placeholder="Teléfono (10 dígitos)" TypeValidation="number" maxlength="10" [(ngModel)]="celular" />
                        </mat-form-field>
                    </div>
                </div>
                <div class="row-sio w-100">
                    <div class="cell-sop w-100">
                        <mat-dialog-actions>
                            <button id="btn_quiero_que_hablen" mat-flat-button class="m-auto font-marcame" [color]="styleCocheSeguro?.colorBtn" id="btnMarcame" [disabled]="valida() || btnAyuda"
                                (click)="obtenerAyuda()">Quiero que me hablen</button>
                        </mat-dialog-actions>
                    </div>
                </div>
                <br>
                <div class="padding-txt">
                    <label class="font-horario">Horario de atención: </label><br>
                    <label class="font-horario">De lunes a domingo de 8:00 a 20:00 hrs </label>
                </div>
            </div>
        </div>
    </div>
</mat-dialog-content>
